export const removeAllCookies = (domain = '.iqiyi.com') => {
  const cookies = document.cookie.split(';')
  if (cookies.length > 0) {
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; Domain=${domain}; path=/`
    }
  }
}

export const getCookieByName = (cookieName, strCookie) => {
  const arrCookie = strCookie && strCookie.split('; ')
  if (!arrCookie) {
    return ''
  }
  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=')
    if (cookieName === arr[0]) {
      return arr[1]
    }
  }
  return ''
}

/**
 * 根据url参数获取参数数组
 */
export const getUrlParamsArr = (name, tempArr = []) => {
  const param = window.location.href.split('?')
  const paramUrlArr = param[1] && param[1].split('&')
  if (!paramUrlArr) {
    return []
  }
  for (const paramUrl of paramUrlArr) {
    const singleParamArr = paramUrl.split('=')
    if (singleParamArr[0] === name) {
      tempArr.push(singleParamArr[1])
    }
  }
  return tempArr
}

/**
 * 返回正确尺寸的图片路径
 * @param url
 * @param param
 * @returns {string}
 */
export const getRightPicSize = (url, param = '480_270') => {
  if (!url) {
    return window.imageDefaultUrl
  }
  const origin = url.slice(0, url.length - 4)
  const extend = url.slice(url.length - 1 - 3, url.length)
  return `${origin}_${param}${extend}`
}

/**
 * get parameter from location
 * @param query
 * @param name
 * @returns {string|null}
 */
export const getParameterValue = (query = '', name) => {
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
  const arr = regex.exec(query)
  if (!arr) {
    return ''
  }
  const value = arr[2]
  if (!value) {
    return ''
  }
  return decodeURIComponent(value.replace(/\//g, ''))
}
